import validator from "validator";
import { PushMessagePayload } from "../../types/message/message-payload";

export const validateNotificationInput = (
  notificationInput: PushMessagePayload
) => {
  const messageTitle = validator.isEmpty(notificationInput.title);
  const messageBody = validator.isEmpty(notificationInput.body);

  return {
    hasError: messageTitle || messageBody,
    validationResults: {
      messageTitle,
      messageBody,
    },
  };
};
